import React from 'react';
import CreateSession from 'containers/CreateSession';
import TestPipelineArticle from 'components/organisms/TestPipelineArticle';

export default () => (
  <CreateSession target='operation'>
    <TestPipelineArticle/>
  </CreateSession>
);
